var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#8E8E8E"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.152 6L9 11.834 15.152 17.667 16 16.794 10.769 11.834 16 6.873z",
    transform: "translate(-759 -2186) translate(444 2173) translate(315 13) matrix(0 -1 -1 0 24.333 24.333)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowExpand);
export default __webpack_public_path__ + "static/media/ic_arrow_expand.f908e1a807553911b01b33bdc3bc28d2.svg";
export { ForwardRef as ReactComponent };